import * as yup from 'yup';
import { REQUIRED_FIELD } from 'constants/validations';

export const initialValuesStepOne = {
  name: '',
  welcomeMessage: '',
  giftDirected: '',
};

export const schemaStepOne = yup.object().shape({
  name: yup.string().required(REQUIRED_FIELD),
  welcomeMessage: yup.string().required(REQUIRED_FIELD),
  giftDirected: yup.string().required(REQUIRED_FIELD),
});

export const titleStepOne = 'Dedicatoria del regalo';
